module.exports = __webpack_public_path__ + "static/media/42.db455a3f.png";